/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
import {useEffect, useRef, useState} from 'react';
import Locale from '../util/Locale';
import Util from '../util/Util';
import './FilterMenu.scss';
import {ReactComponent as ArrowIcon} from '../images/Arrow_icon.svg';

function FilterMenu({x = 0, select, onSelect, showAssets, onDateRangeClick}) {
    const ref = useRef(null);
    const [caretPositionStyle, setCaretPositionStyle] = useState({});
    const [menuPositionStyle, setMenuPositionStyle] = useState({});
    const [isOpen, setIsOpen] = useState(!['all', 'documents', 'videos'].includes(select || ''));

    const setMenuPosition = () => {
        const width = ref.current ? ref.current.clientWidth : 300;
        let menuLeft = x - width / 2;
        if (menuLeft < 0) {
            menuLeft = 5;
        }

        if (menuLeft + width >= window.innerWidth) {
            menuLeft = window.innerWidth - width;
        }
        const caretLeft = Math.abs(x - menuLeft) - 8; // Change this if caret width changes (1/2 of caret width)
        setCaretPositionStyle({left: `${caretLeft}px`});
        setMenuPositionStyle({left: `${menuLeft}px`});
    };

    const closeMenu = () => {
        if (onSelect) {
            onSelect(select);
        }
    };

    useEffect(() => {
        const handleResize = () => closeMenu();
        window.addEventListener('resize', handleResize);
        setMenuPosition();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleSelect = event => {
        if (onSelect) {
            const {id} = event.currentTarget.dataset;
            onSelect(id);
            if (id === Util.ASSET_FILTER_TYPE.IMAGES) {
                setIsOpen(!isOpen);
            }
            // eslint-disable-next-line no-console
            console.log('selected', id);
        }
        event.stopPropagation();
    };

    const renderRadio = (status, id) => {
        if (status) {
            return <nsemble-radio-button key={id} checked />;
        }
        return <nsemble-radio-button key={id} />;
    };

    const renderRow = (id, label) => {
        return (
            <li data-id={id} className={select === id ? 'selected' : ''} onClick={handleSelect}>
                <div>{renderRadio(select === id, id)}</div>
                <span>{label}</span>
            </li>
        );
    };

    const handleDateRangeClick = event => {
        event.stopPropagation();
        if (onDateRangeClick) {
            onDateRangeClick();
        }
    };

    const handleImagesClick = event => {
        if (event.target.closest('.arrow-toggle')) {
            event.stopPropagation();
            setIsOpen(!isOpen);
        } else {
            if (onSelect) {
                onSelect(Util.ASSET_FILTER_TYPE.IMAGES);
            }
            event.stopPropagation();
        }
    };

    const isSubMenuOption = id => {
        return [
            Util.ASSET_FILTER_TYPE.IMAGES,
            Util.IMG_SORT_TYPE.RATIO_4_1,
            Util.IMG_SORT_TYPE.RATIO_4_3,
            Util.IMG_SORT_TYPE.RATIO_10_1,
            Util.IMG_SORT_TYPE.RATIO_9_16
        ].includes(id);
    };

    const isImagesOrSubMenuSelected = select === Util.ASSET_FILTER_TYPE.IMAGES || isSubMenuOption(select);

    const renderImagesMenu = () => {
        return (
            <>
                <li
                    data-id={Util.ASSET_FILTER_TYPE.IMAGES}
                    className={isImagesOrSubMenuSelected ? 'selected' : ''}
                    onClick={handleImagesClick}
                >
                    <div>{renderRadio(isImagesOrSubMenuSelected, Util.ASSET_FILTER_TYPE.IMAGES)}</div>
                    <span>{Locale.getText('IMAGES_ONLY')}</span>
                    <span
                        className="arrow-toggle"
                        onClick={event => {
                            event.stopPropagation();
                            setIsOpen(!isOpen);
                        }}
                    >
                        <ArrowIcon className={isOpen ? 'open' : ''} />
                    </span>
                </li>
                {isOpen && (
                    <ul className="sub-menu">
                        <hr />
                        {renderRow(Util.ASSET_FILTER_TYPE.IMAGES, Locale.getText('ALL_IMAGES'))}
                        {renderRow(Util.IMG_SORT_TYPE.RATIO_4_1, '4:1')}
                        {renderRow(Util.IMG_SORT_TYPE.RATIO_4_3, '4:3')}
                        {renderRow(Util.IMG_SORT_TYPE.RATIO_10_1, '10:1')}
                        {renderRow(Util.IMG_SORT_TYPE.RATIO_9_16, '9:16')}
                    </ul>
                )}
            </>
        );
    };

    if (select !== undefined) {
        const assetsToShow =
            !showAssets || (showAssets && !showAssets.length)
                ? `${Util.ASSET_FILTER_TYPE.IMAGES},${Util.ASSET_FILTER_TYPE.VIDEOS},${Util.ASSET_FILTER_TYPE.DOCUMENTS}`
                : showAssets;
        const showImages = assetsToShow.includes(Util.ASSET_FILTER_TYPE.IMAGES);
        const showVideos = assetsToShow.includes(Util.ASSET_FILTER_TYPE.VIDEOS);
        const showDocs = assetsToShow.includes(Util.ASSET_FILTER_TYPE.DOCUMENTS);
        const showAll = showImages && showVideos && showDocs;

        return (
            <div className="filter-mask" onClick={closeMenu}>
                <div className="filter-menu" ref={ref} style={menuPositionStyle}>
                    <div className="caret" style={caretPositionStyle} />
                    <ul>
                        {showAll && renderRow('all', Locale.getText('SHOW_ALL'))}
                        {showImages && renderImagesMenu()}
                        {showVideos && renderRow(Util.ASSET_FILTER_TYPE.VIDEOS, Locale.getText('VIDEOS_ONLY'))}
                        {showDocs && renderRow(Util.ASSET_FILTER_TYPE.DOCUMENTS, Locale.getText('DOCUMENTS_ONLY'))}
                    </ul>
                    <hr className="date-range-divider" />
                    <div className="date-range-row" data-id="date-range" onClick={handleDateRangeClick}>
                        <div className="date-range-icon">{Util.getDateIcon('#00528A')}</div>
                        <span>{Locale.getText('DATE_RANGE')}</span>
                        <span className="date-range-chevron">
                            <ArrowIcon />
                        </span>
                    </div>
                </div>
            </div>
        );
    }
    return null;
}

export default FilterMenu;
